import { signOut } from 'next-auth/react'

// See [...nextauth].ts for more context. This results in a redirect to
// Cognito, which then redirects back to our app:
export const SIGN_OUT_REDIRECT = 'cognitoSignOut'

export const cognitoSignOut = () => signOut({ callbackUrl: SIGN_OUT_REDIRECT })
